import { useEffect, useRef } from 'react';
import qs from 'query-string';
import { useSetRecipientSessionIDLazyQuery } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useQueryParams } from '@shared/utils/hooks/useQueryParams';

const getInviteeIdFromQueryParams = (params: qs.ParsedQuery<string>): string | null => {
  const inviteeId = params['inviteeId'];

  if (typeof inviteeId === 'string') {
    return inviteeId;
  }

  return null;
};

// Checks query param for an Invitee ID, and creates a session attatched
// to that guest. Enables unlocking guest site and RSVP from links.
export const useInviteeSessionId = () => {
  const { eventInfo } = useEventInfo();
  const eventID = eventInfo?.eventId;
  const hasCreatedSession = useRef(false);

  const queryParams = useQueryParams();

  const [getInviteeSession] = useSetRecipientSessionIDLazyQuery();

  useEffect(() => {
    const inviteeID = getInviteeIdFromQueryParams(queryParams);

    if (inviteeID && eventID && !hasCreatedSession.current) {
      getInviteeSession({
        variables: {
          eventID,
          inviteeID
        }
      });

      hasCreatedSession.current = true;
    }
  }, [eventID, getInviteeSession, queryParams]);
};

type EventSessionProviderProps = {
  children: JSX.Element;
};

export const EventSessionProvider = (props: EventSessionProviderProps) => {
  const { children } = props;

  useInviteeSessionId();

  return children;
};
